import TagManager from 'react-gtm-module'

interface DroppeAdEventParams {
  adLocation: DroppeAdLocation
  adCampaign: string
  adVariant: string
  adName: string
}

type DroppeAdEvents = 'click_droppe_ad' | 'view_droppe_ad'

type DroppeAdLocation = 'category_sidebar' // More will be added once new ad banners are rolled out

const createDroppeAdEvent = (eventName: DroppeAdEvents) => (params: DroppeAdEventParams) => {
  const { adLocation, adCampaign, adName, adVariant } = params
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      droppe_ad_location: adLocation,
      droppe_ad_campaign: adCampaign,
      droppe_ad_name: adName,
      droppe_ad_variant: adVariant,
    },
  })
}

export const clickDroppeAdEvent = createDroppeAdEvent('click_droppe_ad')
export const viewDroppeAdEvent = createDroppeAdEvent('view_droppe_ad')
